import PropTypes from 'prop-types';
import Button from 'components/CustomButtons/Button';

const DownloadReportButton = ({
  children,
  extension,
  onClick,
  isDisabled,
  color = 'success',
  dataCy,
}) => (
  <Button
    className={`btn--generate-${extension}`}
    data-cy={dataCy}
    onClick={onClick}
    disabled={isDisabled}
    color={color}
    round={true}
  >
    {children}
  </Button>
);

DownloadReportButton.propTypes = {
  children: PropTypes.node.isRequired,
  extension: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  dataCy: PropTypes.string,
};

export default DownloadReportButton;
